import { useState } from 'react'
import BookingModal from '../BookingModal'
import styles from './index.module.scss'



export default function BookButton({ eventId, productId }) {

    const [modalIsOpen, setModalIsOpen] = useState(false)

    return (
        <>
            <button type="button" className={styles.button} onClick={() => setModalIsOpen(true)}>Book now</button>
            <BookingModal eventId={eventId} productId={productId} setModalIsOpen={setModalIsOpen} modalIsOpen={modalIsOpen} />
        </>
    )
}